/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import _ from "lodash";
import { VApplication } from "../application";
import { ASSETS_TABLE } from "../pages/AssetsTable/graphql/asset-table.query";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import {getErrorMessage} from "../utils/error.message";
const MODULE_NAME = "CreatedAssetTableService";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export class CreatedAssetTableService {
    private static instance: CreatedAssetTableService;
    private vapp: VApplication;
    private constructor(props: any = {}) {
        this.vapp = VApplication.getInstance();
    }
    public static getInstance(props: any = {}): CreatedAssetTableService {
        if (!CreatedAssetTableService.instance) {
            CreatedAssetTableService.instance = new CreatedAssetTableService(props);
        }
        return CreatedAssetTableService.instance;
    }

    async getCreatedAssetTable(limit: number, skip: number, filter: any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        try {
            if (client) {
                const res = await client.query({
                    query: ASSETS_TABLE,
                    variables: {
                        offset: skip,
                        size: limit,
                    },
                    fetchPolicy: "network-only",
                });
                log.success(MODULE_NAME, "getCreatedAssetTable: ", res);
                if(res?.data?.getCreatedAssetTable){

                    return res?.data?.getCreatedAssetTable;
                }
            }
        } catch (err) {
            getErrorMessage(err);
        }
    }
}
